import {IAlgoliaEventData} from '../../IAlgoliaManager';
import EventModel from '../EventModel';

/**
 * Represents AlgoliaProductSuggestionClickEventModel
 */
export default class AlgoliaProductSuggestionClickEventModel extends EventModel {
	public data: IAlgoliaEventData;

	/**
	 * @constructor
	 * @param {IAlgoliaEventData} data - data
	 */
	constructor(data: IAlgoliaEventData) {
		super(data);

		const {
			productData: {
				productID,
				position
			}
		} = data;

		this.data.objectIDs = [productID];
		this.data.positions = [position];
	}
};
